import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import _, { cloneDeep } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { toastError, toastSuccess, getOrganizationId } from "../../../../../utils";
import { initialCreatePortOperation, termsCoEfficientTable } from "../../../../../constants";
import { initialContractFields, initialVesselContractFields } from "../../Contracts/index";
import { createVesselContract } from "../../../Fleet/action";
import { createCargoContract } from "../../../Orders/actions";
import { createEstimateContract } from "../../actions";

import {
  addPortDistanceToOperations,
  addPortDistanceToSelectedFleet,
  calculationValidation,
  convertPortOperationToDistanceString,
  fleetWithCalculatorDataMapping,
} from "../../VoyageCalculator/utils/dataMapping";
import { placeAddedOperation } from "../../dataMapping";

import {
  fetchSavedResultByIdApi,
  updateCalculatedCostApi,
  addOperationSingleVesselApi,
  deleteOperationSingleVesselApi,
  sendCalculatorDataApi,
  getPortDistanceByPortListApi,
  resetDistanceApi,
  savePortDistanceApi,
} from "../services/singleVesselApi";

import { useSingleVesselStore } from "./useSingleVesselStore";

export function useSingleVesselController(props = {}) {
  const { setLoader = () => { }, loader = false, setIsFullScreen = () => { } } = props;
  const { id = "" } = useParams();
  const location = useLocation();
  const history = useHistory();

  const store = useSingleVesselStore();
  const {
    calculatorData,
    selectedVessels,
    syncBunker,
    isOverride,
    estimationEstId,
    splitHireArray,
    setCalculatorData,
    setPortOperations,
    setFleetList,
    setSelectedVessel,
    setSyncBunker,
    setIsOverride,
    setEstimationEstId,
    setSplitHireArray,
    setPortDistanceResponse,
  } = store;

  const stateRef = useRef(store);
  useEffect(() => {
    stateRef.current = store;
  });

  const fetchPortDistance = useRef(true);
  const swipeableActions = useRef(null);

  const [activeTab, setActiveTab] = useState(0);
  const [showSplitHireModal, setShowSplitHireModal] = useState(false);
  const [supplyModal, setSupplyModal] = useState(false);
  const [openAddOperation, setOpenAddOperation] = useState(false);
  const [openAddOperationIndex, setOpenAddOperationindex] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  const [showExpensesModal, setShowExpensesModal] = useState(false);

  // Contract Modal State
  const organizationId = getOrganizationId();
  const [isStepperOpen, setIsStepperOpen] = useState(false);
  const [modelType, setModelType] = useState("");
  const [selectedEstimate, setSelectedEstimate] = useState({});
  const [vesselAttachments, setVesselAttachments] = useState([]);
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [cargoTextContract, setCargoTextContract] = useState();
  const [vesselTextContract, setVesselTextContract] = useState();
  const [estimateFormData, setEstimateFormData] = useState({});
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [vesselFormData, setVesselFormData] = useState(initialVesselContractFields);

  const [fleetCheckbox, setFleetCheckbox] = useState({
    ballest: { 1: true, 2: true, 3: true, 4: true },
    laden: { 1: true, 2: true, 3: true, 4: true },
  });

  const onFetchAndSetIntitalPortDistance = useCallback(
    (updatedCalculatorData) => {
      if (!fetchPortDistance.current) return Promise.resolve({});
      const { getPortDistanceString, routeList } = convertPortOperationToDistanceString(updatedCalculatorData);
      setLoader(true, "Calculating port distances...");

      return new Promise((resolve) => {
        const { clientQuery = {} } = updatedCalculatorData;
        const { eca = false, hra = false, jwc = false, suez = false, panama = false, singapore = false } = clientQuery;
        const portDataObj = {
          eca, hra, jwc, suez, panama, singapore,
          routeOverride: false,
          routeList,
          portList: getPortDistanceString,
          clientQueryId: id,
          queryId: id,
          getGeometry: true,
        };

        getPortDistanceByPortListApi(portDataObj)
          .then((res) => {
            fetchPortDistance.current = false;
            setPortDistanceResponse(res);
            resolve(res);
          })
          .catch((err) => {
            setLoader(false);
            resolve({});
            toastError(err?.data?.message || "Something went wrong");
          });
      });
    },
    [id, setLoader, setPortDistanceResponse]
  );

  const sendCalculatorResponse = useCallback((modifiedData = {}) => {
    return new Promise((resolve) => {
      if (modifiedData.fleetList.length === 0) return resolve({});

      const { _id, createdUser, lastModifiedUser, userId, calculationFormat, __v, createdAt, updatedAt, isCalculate, ...restClientQuery } = modifiedData.clientQuery;
      const updatedClientQuery = {
        ...restClientQuery,
        cargoList: modifiedData?.cargoList,
      };

      const updatedFleetListData = modifiedData?.fleetList?.length > 0
        ? modifiedData.fleetList.map((fleetDetails) => {
          const vesselDetails = !!fleetDetails?.vessel ? JSON.parse(fleetDetails.vessel) : {};
          const { _id: parseVesselId, userId: parseVesselUserId, createdUser: parseVesselCreatedUser, lastModifiedUser: parseVesselModifiedUser, vesselExtraDetails, __v: parseVessel__v, createdAt, createdDate, lastModifiedDate, pattern, updatedAt, vesselLabel, vesselAHL, vesselCO2, vesselCountry, vesselGrabs, vesselIceClass, vesselIMO, vesselLdnConsmMGO1, vesselLdnConsmMGO2, vesselLightShip, vesselMMSI, vesselType, vesselSource, vesselName, ...parseVesselDetails } = vesselDetails;
          const { _id: fId, vesselId, createdUser: fCU, organizationId: fOrgId, userId: fUserId, lastModifiedUser: fLMU, vesselUniqueId, __v: fV, ...rest } = fleetDetails;
          const uniqueId = vesselUniqueId;

          return {
            ...rest,
            vessel: JSON.stringify({ id: uniqueId, ...parseVesselDetails, system: true }),
            vesselId: uniqueId,
          };
        })
        : [];

      const updatedCargoExtraDetails = (modifiedData.cargoExtraDetails || []).map((cargoextraDetails) => {
        const { _id: cId, ...restCargoMainDetails } = cargoextraDetails;
        const { _id: cargoDetailId, ...restCargoDetail } = cargoextraDetails.cargoDetails;
        return {
          ...restCargoMainDetails,
          cargoDetails: { ...restCargoDetail },
        };
      });

      const calculationData = {
        autoSave: false,
        cargoExtraDetails: updatedCargoExtraDetails,
        cargoList: modifiedData?.cargoList,
        clientQuery: updatedClientQuery,
        fleetList: updatedFleetListData,
      };

      sendCalculatorDataApi(calculationData)
        .then((res) => resolve(res))
        .catch((err) => {
          resolve({});
          toastError(err?.data?.message || "Something went wrong");
        });
    });
  }, []);

  const saveAllResultUpdatedData = useCallback(
    ({ newUpdatedQuery }) => {
      setLoader(true, "Saving calculation results...");
      Promise.all([updateCalculatedCostApi(id, newUpdatedQuery)])
        .then((res) => {
          setLoader(false);
          if (res?.[0]?.success && !newUpdatedQuery?.disableRefetch) {
            getInitialData(id, false);
            toastSuccess("Calculation updated and saved successfully!");
          }
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message);
        });
    },
    [id, setLoader]
  );

  const onChangeFleetRowSelect = useCallback(
    async (fleet = {}, resultCalculatorData = null, changeVessel = false, isPortDistanceChanged = false) => {
      const currentState = stateRef.current;
      let updatedCalculatorData = resultCalculatorData || { ...currentState.calculatorData };
      let commencePort = (fleet && fleet.port) || "";
      let fleetFuelType = (fleet && fleet.vessel && JSON.parse(fleet.vessel)) || {};
      fleetFuelType = fleetFuelType.fuelType || "TYPE0";
      let portOperation = [...updatedCalculatorData.portOperation];

      const portToPortOperationResultMap = (fleet && fleet.portToPortOperationResultMap) || [];
      portOperation = portOperation.map((operation, index) => {
        const selectedResultMap = portToPortOperationResultMap[index] || {};
        const removeDistanceFromResultMap = ({ distanceECA = "", distanceNormal = "", ...rest }) => ({ ...rest });
        if (index !== 0) commencePort = (operation && operation.port) || "";
        let isTermExists = termsCoEfficientTable[0];
        if (operation.terms) {
          isTermExists = termsCoEfficientTable.find((item) => item.label === operation.terms);
        }
        let cargoDetails = { ...operation.cargoDetails };

        if (index === 0) {
          const currentType = fleetFuelType.replace("TYPE", "");
          const { bnkDelhs = 0, bnkDells = 0, bnkDelmgo = 0, bnkPriceDeliveryhs = 0, bnkPriceDeliveryls = 0, bnkPriceDeliverymgo = 0 } = fleet;
          cargoDetails = {
            ...cargoDetails,
            bunkerSuppliedHSFO: bnkDelhs,
            bunkerSuppliedLSFO: bnkDells,
            bunkerSuppliedMGO: bnkDelmgo,
            [`fuelPriceType${currentType}Hsfo`]: bnkPriceDeliveryhs,
            [`fuelPriceType${currentType}Lsfo`]: bnkPriceDeliveryls,
            [`fuelPriceType${currentType}Mgo`]: bnkPriceDeliverymgo,
          };
        }
        return {
          ...operation,
          ...removeDistanceFromResultMap(selectedResultMap),
          cargoDetails,
          port: commencePort,
          terms: isTermExists.label,
          factor: isTermExists.value,
        };
      });

      if (!isPortDistanceChanged) {
        let portDistanceRes = currentState.portDistanceResponse;
        let realData = currentState.realPortDistanceResponse;
        if (fetchPortDistance.current) {
          const { data, realData: realDataRes } = await onFetchAndSetIntitalPortDistance(updatedCalculatorData);
          portDistanceRes = data;
          realData = realDataRes;
        }
        portOperation = addPortDistanceToOperations(portDistanceRes, [...portOperation], realData, true);
      }

      fleet = addPortDistanceToSelectedFleet(portOperation, fleet);

      if (changeVessel || !currentState.selectedVessels._id) {
        setSelectedVessel(fleet);
      }

      setCalculatorData({
        ...updatedCalculatorData,
        clientQuery: {
          ...updatedCalculatorData.clientQuery,
          fuelType: fleetFuelType,
        },
        fleetList: (updatedCalculatorData.fleetList || []).map((singleFleet) => {
          if (singleFleet._id === fleet._id) return fleet;
          return singleFleet;
        }),
        portOperation,
      });
    },
    [onFetchAndSetIntitalPortDistance, setCalculatorData, setSelectedVessel]
  );

  const sendCalculationRequest = useCallback(
    async (sendData) => {
      const currentState = stateRef.current;
      let portDistanceRes = sendData?.portDistanceResponse || currentState.portDistanceResponse;
      let realData = sendData?.clientQuery?.portToPortDistanceReal?.output || currentState.realPortDistanceResponse;
      let payload = sendData?.clientQuery?.portToPortDistanceReal?.payload || currentState.portDistancePayloadResponse;

      if (fetchPortDistance.current) {
        const { data, realData: realDataRes, payload: payloadRes } = await onFetchAndSetIntitalPortDistance(sendData);
        portDistanceRes = data;
        realData = realDataRes;
        payload = payloadRes;
        sendData = {
          ...sendData,
          portOperation: addPortDistanceToOperations(portDistanceRes, [...sendData.portOperation], realData, true),
        };
      }

      sendData = {
        ...sendData,
        clientQuery: {
          ...sendData.clientQuery,
          portToPortDistanceReal: { output: realData, payload },
          portToPortDistance: { output: portDistanceRes, payload },
        },
      };

      let fleetSelected = {};
      const updatedFleedIds = (sendData.fleetList || []).map((fleetDetails) => ({
        ...fleetDetails,
        vesselUniqueId: uuidv4(),
      }));

      let modifiedData = {
        cargoList: sendData.portOperation.filter((item) => !item.isExtra),
        cargoExtraDetails: sendData.portOperation.filter((item) => !!item.isExtra),
        fleetList: cloneDeep(updatedFleedIds),
        clientQuery: {
          ...sendData.clientQuery,
          calculationFormat: sendData.portOperation.map((item) => item._id).join(","),
        },
        autoSave: false,
      };

      await calculationValidation(modifiedData, currentState.selectedVessels);
      setLoader(true, "Calculating pricing and costs...");
      const res = await sendCalculatorResponse(modifiedData);
      setLoader(false);

      const fleetData = fleetWithCalculatorDataMapping(cloneDeep(updatedFleedIds), res?.data);

      if (currentState.selectedVessels && currentState.selectedVessels._id) {
        fleetSelected = fleetData.find((item) => item._id === currentState.selectedVessels._id) || {};
      } else {
        fleetSelected = fleetData[0];
      }

      await onChangeFleetRowSelect(fleetSelected, { ...sendData, fleetList: fleetData }, true, true);

      const newUpdatedQuery = {
        ...currentState.calculatorData,
        cargoList: sendData.portOperation,
        clientQuery: { ...sendData.clientQuery, cargoList: sendData.portOperation },
        createdUser: sendData?.createdUser?._id,
        fleet: fleetData[0],
        vessel: fleetData[0],
        calculatedFleetResult: fleetSelected,
        disableRefetch: sendData?.disableRefetch || false,
      };

      if (sendData.autoSave) {
        saveAllResultUpdatedData({ newUpdatedQuery });
      }
    },
    [onFetchAndSetIntitalPortDistance, onChangeFleetRowSelect, saveAllResultUpdatedData, sendCalculatorResponse, setLoader]
  );

  const getInitialData = useCallback(
    (targetId, shouldFetchDistance = true) => {
      if (shouldFetchDistance) {
        fetchPortDistance.current = true;
      }
      setLoader(true, "Fetching data...");
      fetchSavedResultByIdApi(targetId)
        .then((res) => {
          setLoader(false);
          const { calculatedFleetResult = {}, fleet, clientQuery, _id, estId } = res.data || {};
          const calculatorResult = calculatedFleetResult;
          const portOperation = (clientQuery?.cargoList || []).map((item, index) => ({
            ...item,
            index,
          }));

          if (
            clientQuery?.fuelCalculationMethod === "LIFO" ||
            clientQuery?.fuelCalculationMethod === "FIFO" ||
            clientQuery?.fuelCalculationMethod === "AVERAGE"
          ) {
            setSyncBunker(true);
          }
          if (calculatorResult?.bunkerPriceOverridden) {
            setIsOverride(true);
          }

          let splitHireArr = calculatorResult && calculatorResult.splitHire ? JSON.parse(calculatorResult.splitHire) : [];
          setSplitHireArray(splitHireArr);
          setEstimationEstId(estId || "");

          setCalculatorData({
            portOperation,
            fleetList: [calculatorResult],
            clientQuery,
            _id,
          });

          setSelectedVessel({ ...fleet, ...calculatorResult });
          setIsInitialLoad(true);

          sendCalculationRequest({
            portOperation,
            fleetList: [calculatorResult],
            clientQuery,
            autoSave: false,
          });
        })
        .catch(() => setLoader(false));
    },
    [sendCalculationRequest, setCalculatorData, setEstimationEstId, setIsOverride, setLoader, setSelectedVessel, setSplitHireArray, setSyncBunker]
  );

  useEffect(() => {
    setIsFullScreen(true);
    if (id) {
      getInitialData(id);
    }
    return () => {
      setIsFullScreen(false);
    };
  }, [id]);

  useEffect(() => {
    if (isInitialLoad && new URLSearchParams(location?.search)?.get("code")) {
      sendCalculationRequest({ ...stateRef.current.calculatorData, autoSave: true }).then(() => {
        history.replace(`${location.pathname}`);
      });
    }
  }, [isInitialLoad, location, history, sendCalculationRequest]);

  const onChangeSelectedVessel = useCallback(
    (e, isFleetEdit = false) => {
      const { name = "", value = "", type = "number", checked = false } = e.target || {};
      fetchPortDistance.current = true;
      const currentState = stateRef.current;
      let newUpdatedFleet = { ...currentState.selectedVessels };
      const { fuelType = "" } = currentState.calculatorData.clientQuery || {};
      let updatedvessel = { ...JSON.parse(newUpdatedFleet.vessel || "{}") };

      if (isFleetEdit) {
        newUpdatedFleet[name] = value;
      } else {
        if (type === "checkbox") {
          updatedvessel[name] = checked;
          if (
            name === "vesselBalComb1Selected" ||
            name === "vesselBalComb2Selected" ||
            name === "vesselBalComb3Selected" ||
            name === "vesselBalComb4Selected"
          ) {
            if (!updatedvessel["vesselBalComb1Selected"] && !updatedvessel["vesselBalComb2Selected"] && !updatedvessel["vesselBalComb3Selected"] && !updatedvessel["vesselBalComb4Selected"]) {
              return;
            }
          } else if (
            name === "vesselLadComb1Selected" ||
            name === "vesselLadComb2Selected" ||
            name === "vesselLadComb3Selected" ||
            name === "vesselLadComb4Selected"
          ) {
            if (!updatedvessel["vesselLadComb1Selected"] && !updatedvessel["vesselLadComb2Selected"] && !updatedvessel["vesselLadComb3Selected"] && !updatedvessel["vesselLadComb4Selected"]) {
              return;
            }
          }
        } else {
          updatedvessel[name] = value;
        }
      }

      const updatedFleet = {
        ...newUpdatedFleet,
        vessel: JSON.stringify(updatedvessel),
      };
      setSelectedVessel(updatedFleet);

      const updatedFleetList = (currentState.calculatorData.fleetList || []).map((item) => {
        if (item._id === updatedFleet._id) return updatedFleet;
        return item;
      });

      let updatedPortOperation = [...currentState.calculatorData.portOperation];
      if (name === "bnkPriceDeliveryhs" || name === "bnkPriceDeliveryls" || name === "bnkPriceDeliverymgo") {
        const currentType = fuelType.replace("TYPE", "");
        if (name === "bnkPriceDeliveryhs") updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Hsfo`] = value;
        if (name === "bnkPriceDeliveryls") updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Lsfo`] = value;
        if (name === "bnkPriceDeliverymgo") updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Mgo`] = value;
      }

      if (name === "bnkDelhs" || name === "bnkDells" || name === "bnkDelmgo") {
        if (updatedPortOperation.length) {
          if (name === "bnkDelhs") updatedPortOperation[0].cargoDetails.bunkerSuppliedHSFO = value;
          if (name === "bnkDells") updatedPortOperation[0].cargoDetails.bunkerSuppliedLSFO = value;
          if (name === "bnkDelmgo") updatedPortOperation[0].cargoDetails.bunkerSuppliedMGO = value;
        }
      }

      setCalculatorData({
        ...currentState.calculatorData,
        portOperation: updatedPortOperation,
        fleetList: updatedFleetList,
      });
    },
    [setCalculatorData, setSelectedVessel]
  );

  const onFetchPortOperationDistance = useCallback(
    (reset = false, propCalculator = null, portCanalChecks = {}, isSave = false) => {
      const currentState = stateRef.current;
      let updatedCalculatorData = propCalculator ? { ...propCalculator } : { ...currentState.calculatorData };
      const { getPortDistanceString, routeList } = convertPortOperationToDistanceString(updatedCalculatorData);
      const { clientQuery = {} } = updatedCalculatorData;
      const { eca = false, hra = false, jwc = false, suez = false, panama = false, singapore = false } = clientQuery;

      const portDataObj = {
        eca, hra, jwc, suez, panama, singapore,
        routeOverride: false,
        getGeometry: true,
        ...portCanalChecks,
        routeList,
        portList: getPortDistanceString,
        isVesselVessel: true,
        clientQueryId: id,
        queryId: id,
      };

      const request = reset ? resetDistanceApi(portDataObj) : getPortDistanceByPortListApi(portDataObj);
      setLoader(true, "Recalculating port distances...");

      request
        .then((res) => {
          setLoader(false);
          setPortDistanceResponse(res);
          if (reset) {
            updatedCalculatorData = {
              ...updatedCalculatorData,
              clientQuery: {
                ...updatedCalculatorData.clientQuery,
                portToPortDistance: {
                  ...updatedCalculatorData.clientQuery.portToPortDistance,
                  output: res.data,
                },
              },
            };
          }

          let realData = reset ? JSON.parse(JSON.stringify(res.data)) : res.realData;
          const newPortOperations = addPortDistanceToOperations(
            res.data,
            [...updatedCalculatorData.portOperation],
            realData,
            true,
            reset
          );

          sendCalculationRequest({
            ...updatedCalculatorData,
            clientQuery: {
              ...updatedCalculatorData.clientQuery,
              portToPortDistanceReal: { payload: res.payload, output: realData },
              portToPortDistance: { payload: res.payload, output: res.data },
            },
            portOperation: newPortOperations,
            portDistanceResponse: res.data,
            autoSave: isSave,
            disableRefetch: isSave,
          });
        })
        .catch(() => setLoader(false));
    },
    [id, sendCalculationRequest, setLoader, setPortDistanceResponse]
  );

  const onChangeBunkerScrubber = useCallback(
    (index, e) => {
      const { name = "", value = "" } = e.target;
      const currentState = stateRef.current;
      let newPortOperation = [...currentState.calculatorData.portOperation];
      newPortOperation[index].cargoDetails[name] = Number(value);
      setCalculatorData({ ...currentState.calculatorData, portOperation: newPortOperation });
    },
    [setCalculatorData]
  );

  const onChangeSyncBunker = useCallback(
    (checked) => {
      const currentState = stateRef.current;
      let updatedClientQuery = { ...currentState.calculatorData.clientQuery };
      setSyncBunker(checked);

      let clientQuery = { ...updatedClientQuery, fuelPriceOverridden: checked, fuelCalculationMethod: !updatedClientQuery.fuelCalculationMethod || updatedClientQuery.fuelCalculationMethod === "DEFAULT" ? "LIFO" : updatedClientQuery.fuelCalculationMethod };
      if (!checked) {
        clientQuery = { ...updatedClientQuery, fuelPriceOverridden: checked, fuelCalculationMethod: "DEFAULT" };
      }

      setCalculatorData({
        ...currentState.calculatorData,
        clientQuery,
      });
    },
    [setCalculatorData, setSyncBunker]
  );

  const onDeleteOperations = useCallback(
    (index, cid, opIndex) => {
      fetchPortDistance.current = true;
      setLoader(true, "Deleting operation...");
      deleteOperationSingleVesselApi({ calculatedCostId: id, cargoId: opIndex })
        .then((res) => {
          setLoader(false);
          toastSuccess(res?.message || "Port operation deleted successfully!");
          const currentState = stateRef.current;
          let portOperation = [...currentState.calculatorData.portOperation];
          portOperation.splice(index, 1);
          const updatedSelectedQuery = {
            ...currentState.calculatorData?.clientQuery,
            calculationFormat: res.data.calculationFormat,
          };

          const updatedCalculatorData = {
            ...currentState.calculatorData,
            portOperation,
            clientQuery: updatedSelectedQuery,
          };

          onFetchPortOperationDistance(false, updatedCalculatorData, {}, true);
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message || err?.message || "Failed to delete operation");
        });
    },
    [id, onFetchPortOperationDistance, setLoader]
  );

  const onAddOperations = useCallback(
    (requiredData = {}) => {
      setLoader(true, "Adding new operation...");
      fetchPortDistance.current = true;
      addOperationSingleVesselApi({
        details: { ...initialCreatePortOperation, ...requiredData },
        calculatedCostId: id,
        addIndex: openAddOperationIndex,
      })
        .then((response) => {
          setLoader(false);
          toastSuccess(response?.message || "Port operation added successfully!");
          const currentState = stateRef.current;
          const cargoList = placeAddedOperation(
            currentState.calculatorData.portOperation,
            response.data?.clientQuery?.cargoList || [],
            openAddOperationIndex
          );
          const updatedSelectedQuery = {
            ...currentState.calculatorData.clientQuery,
            cargoList,
            calculationFormat: response.data?.clientQuery?.calculationFormat,
          };

          const updatedCalculatorData = {
            ...currentState.calculatorData,
            clientQuery: updatedSelectedQuery,
            portOperation: cargoList,
          };

          sendCalculationRequest(updatedCalculatorData);
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message || err?.message || "Failed to add operation");
        });
    },
    [id, openAddOperationIndex, sendCalculationRequest, setLoader]
  );

  const onChangePortOperations = useCallback(
    (index, e, cargoUpdate = false) => {
      let { value = "", name = "" } = e.target;
      const currentState = stateRef.current;
      let portOperation = [...currentState.calculatorData.portOperation];

      if (name === "terms") {
        const termFactor = termsCoEfficientTable.find((item) => item.label === value);
        portOperation[index]["terms"] = value;
        portOperation[index]["factor"] = (termFactor && termFactor.value) || 0;
      } else if (cargoUpdate) {
        if (!portOperation[index].cargoDetails) {
          portOperation[index].cargoDetails = {};
        }
        portOperation[index].cargoDetails[name] = value;
      } else {
        portOperation[index][name] = value;
      }

      let updatedCalculatorData = { ...currentState.calculatorData, portOperation };

      if (
        !cargoUpdate &&
        updatedCalculatorData?.clientQuery?.portToPortDistance?.output &&
        portOperation[index - 1] &&
        portOperation[index]?.port
      ) {
        const key = `${portOperation[index - 1]?.port}_${portOperation[index].port}`;
        if (updatedCalculatorData.clientQuery.portToPortDistance.output[key]) {
          updatedCalculatorData.clientQuery.portToPortDistance.output[key][name] = value;
        }
      }

      if (name === "distanceNormal" || name === "distanceECA") {
        const saveData = {
          distEca: portOperation[index].distanceECA,
          distNormal: portOperation[index].distanceNormal,
          openingPort: (portOperation[index - 1] && portOperation[index - 1]["port"]) || "",
          endingPort: portOperation[index]["port"] || "",
        };
        savePortDistanceApi(saveData);
      }
      setCalculatorData(updatedCalculatorData);
    },
    [setCalculatorData]
  );

  const handleReorderOperation = useCallback(
    async (oldIndex, newIndex) => {
      const currentState = stateRef.current;
      const previousPortOps = [...currentState.calculatorData.portOperation];

      const portOps = [...currentState.calculatorData.portOperation];
      const [movedItem] = portOps.splice(oldIndex, 1);
      portOps.splice(newIndex, 0, movedItem);
      const mappedPortOps = portOps.map((item, idx) => ({ ...item, index: idx }));

      setPortOperations(mappedPortOps);

      try {
        await onFetchPortOperationDistance(
          false,
          {
            ...currentState.calculatorData,
            portOperation: mappedPortOps,
          },
          {},
          true
        );
      } catch (err) {
        setPortOperations(previousPortOps);
        toastError(err?.data?.message || err?.message || "Failed to reorder ports.");
      }
    },
    [onFetchPortOperationDistance, setPortOperations]
  );

  const calculationErrors = useMemo(() => {
    let errors = [];
    if (selectedVessels && calculatorData.portOperation.length && calculatorData.fleetList.length) {
      errors = calculationValidation(calculatorData, selectedVessels);
    }
    return errors;
  }, [calculatorData, selectedVessels]);

  const onClickCalculate = useCallback(() => {
    sendCalculationRequest({ ...stateRef.current.calculatorData, autoSave: false });
  }, [sendCalculationRequest]);

  const onClickCalculateAndSave = useCallback(async () => {
    await sendCalculationRequest({ ...stateRef.current.calculatorData, autoSave: true });
  }, [sendCalculationRequest]);

  const onSetOpenMap = useCallback(() => {
    if (id) {
      window.open(`/map/single/${id}`);
    }
  }, [id]);

  const addRow = useCallback(() => {
    const newRow = { hireRate: "", NoDays: "", applied: 0, disable: false };
    const currentState = stateRef.current;
    const fleetItem = currentState.calculatorData.fleetList[0] || {};
    const splitHire = JSON.parse(fleetItem.splitHire || "[]");
    const updatedSplitHire = [...splitHire, newRow];

    setFleetList([{ ...fleetItem, splitHire: JSON.stringify(updatedSplitHire) }]);
    setSplitHireArray(updatedSplitHire);
  }, [setFleetList, setSplitHireArray]);

  const onChangeSplitHire = useCallback(
    (index, event, isDelete) => {
      const currentState = stateRef.current;
      const updatedSplitHireArray = [...currentState.splitHireArray];

      if (isDelete) {
        updatedSplitHireArray.splice(index, 1);
      } else {
        updatedSplitHireArray[index] = {
          ...updatedSplitHireArray[index],
          [event.target.name]: event.target.value,
        };
      }

      setSplitHireArray(updatedSplitHireArray);
      const fleetItem = currentState.calculatorData.fleetList[0] || {};
      setFleetList([{ ...fleetItem, splitHire: JSON.stringify(updatedSplitHireArray) }]);
    },
    [setFleetList, setSplitHireArray]
  );

  const onChangeClientQuery = useCallback(
    (e) => {
      const { name = "", value = "" } = e.target || {};
      const currentState = stateRef.current;
      setCalculatorData({
        ...currentState.calculatorData,
        clientQuery: {
          ...currentState.calculatorData.clientQuery,
          [name]: value,
        },
      });
    },
    [setCalculatorData]
  );

  const setInitialState = useCallback(() => {
    setIsStepperOpen(false);
    setSelectedEstimate({});
    setVesselFormData(initialVesselContractFields);
    setCargoFormData(initialContractFields);
    setEstimateFormData();
    setCargoAttachments([]);
    setCargoTextContract();
    setVesselTextContract();
    setVesselAttachments([]);
  }, []);

  const handleOpenModelForCreateContract = useCallback(() => {
    const currentState = stateRef.current;
    const vesselDetails = currentState.calculatorData?.fleetList?.[0] || {};
    const cargoDetails = currentState.calculatorData?.clientQuery || {};
    const estId = estimationEstId;

    setSelectedEstimate({ vesselDetails, cargoDetails });
    setCargoFormData((prev) => ({ ...prev, cargoList: cargoDetails?.cargoList || [], estId }));
    setVesselFormData((prev) => ({ ...prev, estId }));
    setModelType("vessel-cargo");
    setEstimateFormData({ estId });
    setIsStepperOpen(true);
  }, [estimationEstId]);

  const handleVesselAttachmentUpload = useCallback(async (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter((file) => file.size <= 5 * 1024 * 1024);
      if (validFiles.length !== newFiles.length) alert("Some files exceed the 5 MB size limit and were not added.");
      setVesselAttachments((prev) => [...prev, ...validFiles]);
    }
  }, []);

  const handleCargoAttachmentUpload = useCallback(async (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter((file) => file.size <= 5 * 1024 * 1024);
      if (validFiles.length !== newFiles.length) alert("Some files exceed the 5 MB size limit and were not added.");
      setCargoAttachments((prev) => [...prev, ...validFiles]);
    }
  }, []);

  const handleVesselDataChange = useCallback((e) => {
    const { name, value } = e.target;
    setVesselFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleCargoDataChange = useCallback((e) => {
    const { name, value } = e.target;
    setCargoFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleVesselTextContractUpload = useCallback((e) => {
    if (e.target.files[0]) setVesselTextContract(e.target.files[0]);
  }, []);

  const handleCargoTextContractUpload = useCallback((e) => {
    if (e.target.files[0]) setCargoTextContract(e.target.files[0]);
  }, []);

  const removeCargoAttachment = useCallback((index) => {
    setCargoAttachments((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  }, []);

  const removeVesselAttachment = useCallback((index) => {
    setVesselAttachments((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  }, []);

  const createFormData = (textContract, attachments, payload) => {
    const formData = new FormData();
    if (textContract) {
      const fileType = textContract.type || "application/octet-stream";
      const fileName = textContract.name || "contract.txt";
      const textFile = new File([new Blob([textContract], { type: fileType })], fileName, { type: fileType });
      formData.append("files", textFile);
      formData.append("textContractMetadata", JSON.stringify({ fileType: "textContract" }));
    }
    attachments?.forEach((file) => formData.append("files", file));
    formData.append("data", JSON.stringify(payload));
    return formData;
  };

  const saveCargoVesselContract = useCallback(async () => {
    try {
      const basePayload = { organizationId };
      const { vesselDetails, cargoDetails } = selectedEstimate;

      const vesselContractPayload = {
        ...basePayload,
        ...vesselFormData,
        vesselDetails,
        vesselId: vesselDetails?._id,
        contractType: modelType,
        status: "close",
        estId: estimateFormData?.estId,
      };
      if (!vesselContractPayload.contractName) {
        toastError("Vessel Contract Name is Required");
        return;
      }

      const vesselFormPayload = createFormData(vesselTextContract, vesselAttachments, vesselContractPayload);
      const vesselContractData = await createVesselContract(vesselFormPayload);
      if (!vesselContractData?.vesselContract?._id) throw new Error("Vessel contract creation failed");

      const { cargoList, ...rest } = cargoFormData;

      const cargoContractPayload = {
        ...basePayload,
        ...rest,
        cargoDetails: {
          ...cargoDetails,
          cargoList,
        },
        cargoId: cargoDetails?._id,
        contractType: modelType,
        status: "close",
        estId: estimateFormData?.estId,
      };
      if (!cargoContractPayload.contractName) {
        toastError("Cargo Contract Name is Required");
        return;
      }

      const cargoFormPayload = createFormData(cargoTextContract, cargoAttachments, cargoContractPayload);
      const cargoContractData = await createCargoContract(cargoFormPayload);
      if (!cargoContractData?.cargoContract?._id) throw new Error("Cargo contract creation failed");

      if (estimateFormData) {
        const estimateContractPayload = {
          ...basePayload,
          ...estimateFormData,
          cargoContractId: cargoContractData.cargoContract._id,
          vesselContractId: vesselContractData.vesselContract._id,
          vesselContractDetails: vesselContractData.vesselContract,
          cargoContractDetails: cargoContractData.cargoContract,
          contractType: modelType,
        };
        if (!estimateContractPayload.contractName) {
          toastError("Estimate Contract Name is Required");
          return;
        }
        const estimateContractData = await createEstimateContract(estimateContractPayload);
        if (!estimateContractData) throw new Error("Estimate contract creation failed");

        toastSuccess("Contract Created Successfully");
        setInitialState();
      }
    } catch (error) {
      toastError(error?.message || "Contract creation failed");
    }
  }, [cargoAttachments, cargoFormData, cargoTextContract, estimateFormData, modelType, organizationId, selectedEstimate, setInitialState, vesselAttachments, vesselFormData, vesselTextContract]);

  return {
    calculatorData,
    selectedVessels,
    syncBunker,
    isOverride,
    activeTab,
    setActiveTab,
    showSplitHireModal,
    setShowSplitHireModal,
    supplyModal,
    setSupplyModal,
    openAddOperation,
    setOpenAddOperation,
    setOpenAddOperationindex,
    showExpensesModal,
    setShowExpensesModal,
    fleetCheckbox,
    setFleetCheckbox,
    swipeableActions,
    calculationErrors,

    // Contract state
    isStepperOpen,
    vesselFormData,
    setVesselFormData,
    cargoFormData,
    setCargoFormData,
    cargoAttachments,
    vesselAttachments,
    modelType,
    selectedEstimate,
    estimateFormData,
    setEstimateFormData,
    cargoTextContract,
    vesselTextContract,
    setCargoTextContract,
    setVesselTextContract,

    // Actions
    getInitialData,
    onChangeSelectedVessel,
    onChangePortOperations,
    onAddOperations,
    onDeleteOperations,
    onFetchPortOperationDistance,
    onChangeBunkerScrubber,
    onChangeSyncBunker,
    onChangeClientQuery,
    onClickCalculate,
    onClickCalculateAndSave,
    onSetOpenMap,
    addRow,
    onChangeSplitHire,
    handleReorderOperation,

    // Contract Handlers
    handleOpenModelForCreateContract,
    handleCargoAttachmentUpload,
    handleVesselAttachmentUpload,
    handleCargoDataChange,
    handleVesselDataChange,
    handleVesselTextContractUpload,
    handleCargoTextContractUpload,
    removeCargoAttachment,
    removeVesselAttachment,
    saveCargoVesselContract,
    setInitialState,
    setCalculatorData,
    setSelectedVessel,
    setIsOverride,
  };
}
